module.exports = __webpack_public_path__ + "static/media/SZ45003W.eb5e4040.png";